export default "__VITE_ASSET__osuYJVgL__"